import Promise from 'es6-promise';

export function getCharLength(str) {
    var len = 0;
    for (var i = 0, strLen = str.length; i < strLen; i++) {
        var c = str.charCodeAt(i);
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
            len++;
        } else {
            len += 2;
        }
    }
    return len;
}

/**
 * 动态插入script标签，返回promise
 * @param {*} url: 要加载的代码url
 */
export function loadScript(url) {
    return new Promise((resolve, reject) => {
        var script = document.createElement('script');
        script.className = 'dynamic-script';
        script.type = 'text/javascript';
        if (script.readyState) { // IE
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    resolve();
                }
            };
        } else { // Others
            script.onload = function() {
                return resolve();
            };
        }
        script.onerror = function() {
            return reject();
        };
        script.src = url;
        document.getElementsByTagName('script')[0].parentNode.appendChild(script);
    });
}

// 添加样式文件
export function addStyles(url) {
    let hm = document.createElement('link');
    hm.href = url;
    hm.rel = 'stylesheet';
    let s = document.getElementsByTagName('link')[0];
    s.parentNode.insertBefore(hm, s);
}

export const Events = {
    get(key) {
        let events = (localStorage.events && JSON.parse(localStorage.events)) || {};
        return events[key];
    },
    set(key, value) {
        let events = (localStorage.events && JSON.parse(localStorage.events)) || {};
        events[key] = value;
        localStorage.events = JSON.stringify(events);
    }
};

/**
* 时间戳转日期时间
* @param {Number} time: 时间戳
* @param {String} format: 日期时间格式
* 使用方式: timestampToTime(1557285692393, 'Y-M-D h:m:s') // 2019-05-08 11:21:32
*/
export function timestampToTime(time, format) {
    let timestamp;
    timestamp = time.length === 10 ? time * 1000 : time;
    if (!format) {
        format = 'Y-M-D h:m:s';
    }
    let formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
    let returnArr = [];
    let date = new Date(timestamp);
    returnArr.push(date.getFullYear());
    let m = date.getMonth() + 1;
    returnArr.push(m < 10 ? ('0' + m) : m);
    let d = date.getDate();
    returnArr.push(d < 10 ? ('0' + d) : d);
    let h = date.getHours();
    returnArr.push(h < 10 ? ('0' + h) : h);
    m = date.getMinutes();
    returnArr.push(m < 10 ? ('0' + m) : m);
    let s = date.getSeconds();
    returnArr.push(s < 10 ? ('0' + s) : s);
    for (let i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i]);
    }
    return format;
}

/**
  * 时间戳转日期时间
  * @param {Number} time: 时间戳
  * @param {String} formatDay: 日期时间格式
  * 使用方式: formatDay(1557285692393, 'Y年M月D日') // 2019年5月8日
  */
export function formatDay(time, day) {
    let timestamp;
    timestamp = time.length === 10 ? time * 1000 : time;
    if (!day) {
        day = 'Y日M月D日';
    }
    let formateArr = ['Y', 'M', 'D'];
    let returnArr = [];
    let date = new Date(timestamp);
    returnArr.push(date.getFullYear());
    let m = date.getMonth() + 1;
    returnArr.push(m);
    let d = date.getDate();
    returnArr.push(d);
    for (let i in returnArr) {
        day = day.replace(formateArr[i], returnArr[i]);
    }
    return day;
}

export function getCookie(key) {
    let objCookie = {};
    let arrCookie = document.cookie.split(';') || [];
    arrCookie.forEach(item => {
        let arrItem = item.split('=');
        objCookie[arrItem[0].trim()] = arrItem[1];
    });
    return objCookie[key];
}

// 字符串拼接
export function strFormat(str) {
    return str < 10 ? `0${str}` : str;
}

// 时间戳转日期
export function timeStamp(time) {
    const dates = new Date(time);
    const year = dates.getFullYear();
    const month = dates.getMonth() + 1;
    const date = dates.getDate();
    const day = dates.getDay();
    const hour = dates.getHours();
    const min = dates.getMinutes();
    const days = ['日', '一', '二', '三', '四', '五', '六'];
    return {
        allDate: `${year}-${strFormat(month)}-${strFormat(date)}`,
        date: `${strFormat(month)}月${strFormat(date)}日`, // 返回的日期 07-01
        day: `${days[day]}`, // 返回的礼拜天数  星期一
        hour: strFormat(hour) + ':' + strFormat(min) // 返回的时钟 08:00
    };
}
/**
  * 判断复杂数据类型
  * @param  {[object, string]} 要判断的对象和类型
  * @return {[boolean]} 是否属于
  */
const isType = (obj, type) => {
    if (typeof obj !== 'object') return false;
    const typeString = Object.prototype.toString.call(obj);
    let flag;
    switch (type) {
    case 'Array':
        flag = typeString === '[object Array]';
        break;
    case 'Date':
        flag = typeString === '[object Date]';
        break;
    case 'RegExp':
        flag = typeString === '[object RegExp]';
        break;
    default:
        flag = false;
    }
    return flag;
};

const getRegExp = re => {
    var flags = '';
    if (re.global) flags += 'g';
    if (re.ignoreCase) flags += 'i';
    if (re.multiline) flags += 'm';
    return flags;
};

/**
  * 深度克隆
  * @param  {[type]} parent object 需要进行克隆的对象
  * @return {[type]}        深克隆后的对象
  */
export function cloneDeep(parent) {
    const parents = [];
    const children = [];

    const _clone = parent => {
        if (parent === null) return null;
        if (typeof parent !== 'object') return parent;

        let child, proto;

        if (isType(parent, 'Array')) {
        // 对数组做特殊处理
            child = [];
        } else if (isType(parent, 'RegExp')) {
        // 对正则对象做特殊处理
            child = new RegExp(parent.source, getRegExp(parent));
            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
        } else if (isType(parent, 'Date')) {
        // 对 Date 对象做特殊处理
            child = new Date(parent.getTime());
        } else {
        // 处理对象原型
            proto = Object.getPrototypeOf(parent);
            // 利用Object.create切断原型链
            child = Object.create(proto);
        }

        // 处理循环引用
        const index = parents.indexOf(parent);

        if (index !== -1) {
        // 如果父数组存在本对象,说明之前已经被引用过,直接返回此对象
            return children[index];
        }
        parents.push(parent);
        children.push(child);

        for (let i in parent) {
        // 递归
            child[i] = _clone(parent[i]);
        }

        return child;
    };

    return _clone(parent);
}

/**
   * 获取设备操作系统
   */
export function getOS() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = '';

    if (~macosPlatforms.indexOf(platform)) {
        os = 'Mac OS';
    } else if (~iosPlatforms.indexOf(platform)) {
        os = 'iOS';
    } else if (~windowsPlatforms.indexOf(platform)) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    return os;
}

/**
   * 获取设备操作系统版本
   */
export function getOSVersion() {
    let os = getOS();
    let osVersion = 'unknown';
    let version = '';
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
    case 'Android':
        osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
        break;

    case 'iOS':
        osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
        break;

    case 'Mac OS':
    case 'Mac OS X':
        version = /Mac OS X (10[._\d]+)/.exec(nAgt);
        osVersion = version ? version[1] : '';
        break;
    }

    return osVersion;
}

/**
 * @param {Object} classLength
 */
export function filterClassHour(classLength) {
    if (classLength) {
        let arr = [];
        [45, 40].forEach(time => {
            ['scp', 'bound', 'boundScp'].forEach(type => {
                let key = `${type}${time}`;
                if (classLength[key]) {
                    arr.push(...Array(classLength[key]).fill(`${time}min`));
                }
            });
        });
        return arr.join('+');
    }
}

/**
 * @param {Array}
 */
export function filterCoursewareData(list) {
    if (list) {
        list.forEach((pptData) => {
            delete pptData.structure;
            if (pptData.pptJson || pptData.questions) {
                pptData.pptJson && filterCoursewareData(pptData.pptJson);
                pptData.questions && filterCoursewareData(pptData.questions);
            }
        });
        return list;
    }
}

export function setStructureData(links, json) {
    for (let link of links) {
        let { subLinks } = link;

        if (subLinks && subLinks.length) {
            setStructureData(subLinks, json);
        }

        (link.contents || []).forEach(item => {
            item.structure = json[item.uId];
        });
    }
}

function getIntegerBits(val, start, end) {
    let base16 = returnBase(val, 16);
    let quadArray = [];
    let quadString = '';
    let i = 0;
    for (i = 0; i < base16.length; i++) {
        quadArray.push(base16.substring(i, i + 1));
    }
    for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
        if (!quadArray[i] || quadArray[i] === '') {
            quadString += '0';
        } else {
            quadString += quadArray[i];
        }
    }
    return quadString;
}

function returnBase(number, base) {
    return (number).toString(base).toUpperCase();
}

function rand(max) {
    return Math.floor(Math.random() * (max + 1));
}

export function createUUID() {
    let dg = new Date(1582, 10, 15, 0, 0, 0, 0);
    let dc = new Date();
    let t = dc.getTime() - dg.getTime();
    let tl = getIntegerBits(t, 0, 31);
    let tm = getIntegerBits(t, 32, 47);
    let thv = getIntegerBits(t, 48, 59) + '1';
    let csar = getIntegerBits(rand(4095), 0, 7);
    let csl = getIntegerBits(rand(4095), 0, 7);
    let n = getIntegerBits(rand(8191), 0, 7) +
    getIntegerBits(rand(8191), 8, 15) +
    getIntegerBits(rand(8191), 0, 7) +
    getIntegerBits(rand(8191), 8, 15) +
    getIntegerBits(rand(8191), 0, 15);
    return tl + tm + thv + csar + csl + n;
}
// 处理数学符号
export function handleMathJax() {
    MathJax.Hub.Config({
        tex2jax: {
            inlineMath: [['$', '$']]
        },
        'HTML-CSS': {linebreaks: {automatic: true}, matchFontHeight: false},
        SVG: {linebreaks: {automatic: true}, matchFontHeight: false}
    });
    MathJax.Hub.Configured();
    MathJax.Hub.Queue(['Typeset', MathJax.Hub, function() {
        let questionOptions = document.getElementsByClassName('question-options');
        for (let ix = 0, ixL = questionOptions.length; ix < ixL; ix++) {
            let questionOption = questionOptions[ix];
            try {
                questionOption.setAttribute('class', questionOption.className.replace(/ul-\d/g, ''));
            } catch (err) {
                return err;
            }
            let choiceOptions = questionOption.childNodes;
            let maxWidth = 0;
            let boxWidth = questionOption.offsetWidth;
            for (let co = 0, coL = choiceOptions.length; co < coL; co++) {
                if (isNaN(co)) {
                    continue;
                }

                choiceOptions[co].setAttribute('data-width', choiceOptions[co].offsetWidth);
                if (choiceOptions[co].offsetWidth > maxWidth) {
                    maxWidth = choiceOptions[co].offsetWidth;
                }
            }

            try {
                if (maxWidth > boxWidth * 0.44) {
                    questionOption.setAttribute('class', [questionOption.className, 'ul-1'].join(' '));
                } else if (maxWidth > boxWidth * 0.21) {
                    questionOption.setAttribute('class', [questionOption.className, 'ul-2'].join(' '));
                } else {
                    questionOption.setAttribute('class', [questionOption.className, 'ul-4'].join(' '));
                }
            } catch (err) {
                return err;
            }
        }
    }]);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils.js